import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'PercentInput' }

import { computed, type PropType } from 'vue'

// Percentage field: the money-input chrome with a "%" suffix badge, bounded
// 0 to 100 by default. Emits null when cleared, like MoneyInput.

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: { type: Number as PropType<number | null>, default: null },
  label: { type: String, default: '' },
  min: { type: Number, default: 0 },
  max: { type: Number, default: 100 },
  precision: { type: Number, default: 0 },
  step: { type: Number, default: 1 },
  placeholder: { type: String, default: '0' },
  disabled: { type: Boolean, default: false },
  error: { type: [Boolean, String] as PropType<boolean | string>, default: false }
},
  emits: ["input", "change"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: number | null): void
  (e: 'change', value: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const errorMessage = computed(() => (typeof props.error === 'string' ? props.error : ''))

function onInput(val: number | null | undefined) {
  emit('input', val == null ? null : val)
}

function onChange(val: number | null | undefined) {
  emit('change', val == null ? null : val)
}

return { __sfc: true,props, emit, errorMessage, onInput, onChange }
}

})